import HeatmapErrorToast from './HeatmapErrorToast';

export default HeatmapErrorToast;
